import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ChangeDetectorRef,
  effect,
} from '@angular/core';
import { Subscription } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';
import { BrandingComponent } from './branding.component';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MaterialModule } from 'src/app/material.module';
import { NavService } from 'src/app/services/nav.service';
import { CoreService } from 'src/app/services/core.service';

@Component({
  selector: 'app-sidebar',
  imports: [BrandingComponent, TablerIconsModule, MaterialModule, TranslateModule],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
})
export class SidebarComponent implements OnInit, OnDestroy {
  protected readonly navService = inject(NavService);
  private readonly settings = inject(CoreService);
  private readonly cdr = inject(ChangeDetectorRef);
  private settingsSubscription = Subscription.EMPTY;

  @Input() showToggle = true;
  @Input() showSidenavDockToggle = false;
  @Output() toggleMobileNav = new EventEmitter<void>();
  @Output() toggleCollapsed = new EventEmitter<void>();

  protected sidenavCollapsedState = true;

  constructor() {
    effect(() => {
      this.navService.hasExpandedNavDropdowns();
      this.cdr.markForCheck();
    });
  }

  protected get showSidebarCollapseDropdowns(): boolean {
    return (
      this.showSidenavDockToggle &&
      !this.sidenavCollapsedState &&
      this.navService.hasExpandedNavDropdowns()
    );
  }

  ngOnInit(): void {
    this.refreshSidenavCollapsedState();
    this.settingsSubscription = this.settings.notify.subscribe(() => {
      this.refreshSidenavCollapsedState();
      this.cdr.markForCheck();
    });
  }

  ngOnDestroy(): void {
    this.settingsSubscription.unsubscribe();
  }

  private refreshSidenavCollapsedState(): void {
    this.sidenavCollapsedState = this.settings.getOptions().sidenavCollapsed;
  }

  collapseAllDropdowns(): void {
    this.navService.collapseAllNavDropdowns();
  }

}
